import { SEVERITY_UI } from '@baseline/shared';

import { severityColour } from './icons.js';

import type { Severity } from '@baseline/shared';

/** Prototype `donutSvg(counts, size)`: open alerts by severity, High drawn first. */
export function Donut({ counts, size = 150 }: { counts: Record<Severity, number>; size?: number }) {
  const total = counts[0] + counts[1] + counts[2];
  const R = 54;
  const CI = 2 * Math.PI * R;
  let off = 0;
  const segs = ([2, 1, 0] as const).flatMap((l) => {
    if (!counts[l]) return [];
    const len = (CI * counts[l]) / total;
    const seg = (
      <circle
        key={l}
        cx="70"
        cy="70"
        r={R}
        fill="none"
        stroke={severityColour(l)}
        strokeWidth="16"
        strokeDasharray={`${len.toFixed(2)} ${(CI - len).toFixed(2)}`}
        strokeDashoffset={(-off).toFixed(2)}
        transform="rotate(-90 70 70)"
      >
        <title>{`${SEVERITY_UI[l].label}: ${String(counts[l])}`}</title>
      </circle>
    );
    off += len;
    return [seg];
  });
  return (
    <svg
      viewBox="0 0 140 140"
      width={size}
      height={size}
      role="img"
      aria-label={`Open alerts by severity: ${String(counts[2])} high, ${String(counts[1])} medium, ${String(counts[0])} low`}
    >
      <circle cx="70" cy="70" r={R} fill="none" stroke="var(--slate-wash)" strokeWidth="16" />
      {segs}
      <text
        x="70"
        y="66"
        textAnchor="middle"
        dominantBaseline="central"
        fontFamily="DM Sans,sans-serif"
        fontSize="30"
        fontWeight="700"
        fill="var(--ink)"
      >
        {total}
      </text>
      <text
        x="70"
        y="88"
        textAnchor="middle"
        fontFamily="DM Sans,sans-serif"
        fontSize="10"
        fill="var(--muted)"
      >
        open
      </text>
    </svg>
  );
}
